import { Modal, Button } from "react-bootstrap";

const AlertModalAssign = ({ show, handleClose, deleteCart, name }) => {
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="500px"
        aria-labelledby="contained-modal-title-vcenter"
        className="alert-modal"
        centered
      >
        {/* <Modal.Header closeButton className="modal-header">
                    <Modal.Title>Favourite Delete Alert</Modal.Title>
                </Modal.Header> */}
       
        <Modal.Body className="modal-body invalidemailshowfp">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none">
        <path d="M23.7526 18.5469L13.7682 1.48438C13.3463 0.828125 12.69 0.5 12.0338 0.5C11.3307 0.5 10.6744 0.828125 10.2526 1.48438L0.221349 18.5469C-0.481776 19.8594 0.455729 21.5 2.0026 21.5H22.0182C23.5651 21.5 24.5026 19.8594 23.7526 18.5469ZM2.47135 19.25L11.9869 2.98438L21.5494 19.25H2.47135ZM12.0338 14.8438C11.19 14.8438 10.5338 15.5 10.5338 16.2969C10.5338 17.0938 11.19 17.75 12.0338 17.75C12.8307 17.75 13.4869 17.0938 13.4869 16.2969C13.4869 15.5 12.8307 14.8438 12.0338 14.8438ZM10.9088 7.625V12.125C10.9088 12.7812 11.3776 13.25 12.0338 13.25C12.6432 13.25 13.1588 12.7812 13.1588 12.125V7.625C13.1588 7.01562 12.6432 6.5 12.0338 6.5C11.3776 6.5 10.9088 7.01562 10.9088 7.625Z" fill="#2d2d2d"/>
      </svg>
          Are you sure you want to delete {name}?
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="secondary"
            className="confirm"
            onClick={() => {
              handleClose();
            }}
          >
            No
          </Button>
          <Button variant="primary" className="confirm" onClick={deleteCart}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default AlertModalAssign;
